/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/react';

export const inputLabelOverride = css`
  padding-right: 23px;
`;
